import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/Hotel/tab/Room/room-tab.html";

@WithRender
@Component
export default class RoomTab extends Vue {
  protected ui: any = {};
  protected errors: any = {};
  protected isError: boolean = false;
  constructor() {
    super();
    this.ui.Isloading = false;
  }
  public redirectToRoomInfo() {
    this.$router.push({
      name: "create-business-hotel-room-info",
      query: {
        id: this.$route.query.id
      }
    });
  }



}
